/**
 * 新闻资讯管理后台api
 * 新闻资讯管理后台相关接口
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import NewsAdminSummaryVo from './NewsAdminSummaryVo';




  /**
   * The PagingNewsAdminVo model module.
   * @module news/model/PagingNewsAdminVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>PagingNewsAdminVo</code>.
   * @alias module:news/model/PagingNewsAdminVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>PagingNewsAdminVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:news/model/PagingNewsAdminVo} obj Optional instance to populate.
   * @return {module:news/model/PagingNewsAdminVo} The populated <code>PagingNewsAdminVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'list')) {
        obj['list'] = ApiClient.convertToType(data['list'], [NewsAdminSummaryVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'hasNextPage')) {
        obj['hasNextPage'] = ApiClient.convertToType(data['hasNextPage'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'totalCount')) {
        obj['totalCount'] = ApiClient.convertToType(data['totalCount'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 新闻列表
   * @member {Array.<module:news/model/NewsAdminSummaryVo>} list
   */
  exports.prototype['list'] = undefined;
  /**
   * 是否有下一页
   * @member {Boolean} hasNextPage
   */
  exports.prototype['hasNextPage'] = undefined;
  /**
   * 总记录数
   * @member {Integer} totalCount
   */
  exports.prototype['totalCount'] = undefined;



  export default exports;
;


